export default "__VITE_ASSET__DOsWjQ4A__"